// Copyright (c) Move Closer 2022.

import { Model } from '@movecloser/front-core'

import { IUser, UserData } from '../../auth/shared'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export class User extends Model<UserData> implements IUser {
  protected boot (): void {
    this.initialValues = {}
    this.modelProperties = [
      'addresses',
      'dateOfBirth',
      'email',
      'firstName',
      'isPremium',
      'isSubscribed',
      'lastName'
    ]
  }

  public getFullName (): string {
    return this._data.firstName + ' ' + this._data.lastName
  }
}
